import { useEffect, useState } from 'react';
import { isUseO2Token } from 'reactApp/api/O2AuthClient';
import { WorkspaceSuperAppService } from 'reactApp/services';
import { WorkspaceSuperAppSourceLoader } from 'reactApp/services/WorkspaceSuperAppSourceLoader';
import { o2AuthedSourceLoader } from 'reactApp/ui/ReactViewer/O2AuthedSourceLoader';

export const useAuthedImage = (src: string, ext: string) => {
    const [imageSrc, setImageSrc] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    const isO2Mode = isUseO2Token();
    const isWorkspaceSuperAppMode = WorkspaceSuperAppService.isEnabled;
    const isNeedFetchAuthImage = isO2Mode || isWorkspaceSuperAppMode;

    useEffect(() => {
        if (!isNeedFetchAuthImage) {
            return;
        }

        setIsLoading(true);
        setError(null);

        const loadImage = async () => {
            try {
                let base64: string;

                if (isO2Mode) {
                    const blob = await o2AuthedSourceLoader.getAuthedSourceByExt(src, ext);

                    base64 = await o2AuthedSourceLoader.getBase64FromBlob(blob);
                } else {
                    base64 = await WorkspaceSuperAppSourceLoader.fetchImageAsBase64(src);
                }

                setImageSrc(base64);
            } catch (err) {
                setError(err instanceof Error ? err : new Error('Failed to load image'));
            } finally {
                setIsLoading(false);
            }
        };

        loadImage();
    }, [ext, isNeedFetchAuthImage, isO2Mode, src]);

    return { imageSrc, isLoading, error };
};
